import { __ } from '@wordpress/i18n';

export const FIELD_TYPES = {
  IMAGE: 'image',
  CAROUSEL: 'carousel',
  BADGE: 'badge',
  STATUS: 'status',
  TIME: 'time',
  FAVORITE: 'favorite',
  SHARE: 'share',
  VIEWS: 'views',
  TITLE: 'title',
  RATING: 'rating',
  PHONE: 'phone',
  EMAIL: 'email',
  WEBSITE: 'website',
  ADDRESS: 'address',
  DATETIME: 'datetime',
  PRICE: 'price',
  PRICE_PER_SQFT: 'price-per-sqft',
  BEDS: 'beds',
  BATHS: 'baths',
  KITCHENS: 'kitchens',
  FLOOR: 'floor',
  ROOMS: 'rooms',
  RECEPTIONS: 'receptions',
  SQFT: 'sqft',
  GSFT: 'gsft',
  BUTTON: 'button',
  VIEW_BUTTON: 'view-btn', // NEW: Separate button type for View Property
  SCHEDULE_TOUR_BUTTON: 'schedule-tour-button', // NEW: Separate button type for Schedule Tour
  FEATURE: 'feature',
  EXCERPT: 'excerpt',
  LOCATION: 'location',
  SCHEDULE_TOUR: 'schedule-tour',
  PROPERTY_TYPE: 'property_type',
  AVATAR: 'avatar'
};

// Field modes for controlling display
export const FIELD_MODES = {
  DEFAULT: 'default',
  PRESET: 'preset',
  BOTH: 'both'
};

export const FIELD_CONFIGS = [
  { 
    id: FIELD_TYPES.IMAGE, 
    title: __('Property Image', 'havenlytics'), 
    icon: 'image', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { type: 'single', url: '' } 
  },
  { 
    id: FIELD_TYPES.CAROUSEL, 
    title: __('Image Carousel', 'havenlytics'), 
    icon: 'images', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { type: 'carousel', images: [] } 
  },
{ 
  id: FIELD_TYPES.BADGE, 
  title: __('Badge', 'havenlytics'), 
  icon: 'tag', 
  mode: FIELD_MODES.BOTH,
  defaultValue: { text: __('Featured', 'havenlytics'), style: 'primary' } // Changed from "New Badge" to "Featured"
},
  { 
    id: FIELD_TYPES.SCHEDULE_TOUR, 
    title: __('Schedule Tour', 'havenlytics'), 
    icon: 'calendar-alt', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { text: __('Schedule Tour', 'havenlytics'), icon: 'calendar-alt' } 
  },
  { 
    id: FIELD_TYPES.STATUS, 
    title: __('Status', 'havenlytics'), 
    icon: 'certificate', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { text: __('Active', 'havenlytics'), color: 'green' } 
  },
  { 
    id: FIELD_TYPES.TIME, 
    title: __('Time', 'havenlytics'), 
    icon: 'clock', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { text: __('2 days ago', 'havenlytics') } 
  },
  { 
    id: FIELD_TYPES.FAVORITE, 
    title: __('Favorite', 'havenlytics'), 
    icon: 'heart', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { isFavorite: false } 
  },
  { 
    id: FIELD_TYPES.SHARE, 
    title: __('Share', 'havenlytics'), 
    icon: 'share-alt', 
    mode: FIELD_MODES.BOTH 
  },
  { 
    id: FIELD_TYPES.VIEWS, 
    title: __('Views', 'havenlytics'), 
    icon: 'eye', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { count: 0 } 
  },
  { 
    id: FIELD_TYPES.TITLE, 
    title: __('Title', 'havenlytics'), 
    icon: 'heading', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { text: __('Luxury Villa with Ocean View', 'havenlytics') } 
  },
  { 
    id: FIELD_TYPES.RATING, 
    title: __('Rating', 'havenlytics'), 
    icon: 'star', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: 4.5, max: 5 } 
  },
  { 
    id: FIELD_TYPES.PHONE, 
    title: __('Phone', 'havenlytics'), 
    icon: 'phone', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { number: '+1 234 567 8900' } 
  },
  { 
    id: FIELD_TYPES.EMAIL, 
    title: __('Email', 'havenlytics'), 
    icon: 'envelope', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { address: 'contact@example.com' } 
  },
  { 
    id: FIELD_TYPES.WEBSITE, 
    title: __('Website', 'havenlytics'), 
    icon: 'globe', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { url: 'www.example.com' } 
  },
  { 
    id: FIELD_TYPES.ADDRESS, 
    title: __('Address', 'havenlytics'), 
    icon: 'map-marker', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { text: __('123 Main St, City', 'havenlytics') } 
  },
  { 
    id: FIELD_TYPES.DATETIME, 
    title: __('Date/Time', 'havenlytics'), 
    icon: 'clock', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { text: __('Posted 2 days ago', 'havenlytics') } 
  },
  { 
    id: FIELD_TYPES.PRICE, 
    title: __('Price', 'havenlytics'), 
    icon: 'dollar-sign', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '1,250,000', currency: 'USD' } 
  },
  { 
    id: FIELD_TYPES.PRICE_PER_SQFT, 
    title: __('Price per Sq Ft', 'havenlytics'), 
    icon: 'chart-line', 
    mode: FIELD_MODES.PRESET,
    defaultValue: { value: '4,200', currency: 'USD' } 
  },
  { 
    id: FIELD_TYPES.BEDS, 
    title: __('Beds', 'havenlytics'), 
    icon: 'bed', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '3' } 
  },
  { 
    id: FIELD_TYPES.BATHS, 
    title: __('Baths', 'havenlytics'), 
    icon: 'bath', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '2' } 
  },
  { 
    id: FIELD_TYPES.RECEPTIONS, 
    title: __('Receptions', 'havenlytics'), 
    icon: 'door-open', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '2' } 
  },
  { 
    id: FIELD_TYPES.SQFT, 
    title: __('Square Feet', 'havenlytics'), 
    icon: 'expand-arrows-alt', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '2,980' } 
  },
  // UPDATED: Changed from generic BUTTON to specific button types
  { 
    id: FIELD_TYPES.VIEW_BUTTON, 
    title: __('View Property Button', 'havenlytics'), 
    icon: 'external-link-alt', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { 
      text: __('View Property', 'havenlytics'), 
      style: 'primary',
      type: 'view-property'
    } 
  },
  { 
    id: FIELD_TYPES.SCHEDULE_TOUR_BUTTON, 
    title: __('Schedule Tour Button', 'havenlytics'), 
    icon: 'calendar-alt', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { 
      text: __('Schedule Tour', 'havenlytics'), 
      style: 'primary',
      type: 'schedule-tour'
    } 
  },
  { 
    id: FIELD_TYPES.FEATURE, 
    title: __('Feature', 'havenlytics'), 
    icon: 'star', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { icon: 'swimming-pool', label: __('Pool', 'havenlytics') } 
  },
  { 
    id: FIELD_TYPES.EXCERPT, 
    title: __('Excerpt', 'havenlytics'), 
    icon: 'align-left', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { text: __('Stunning oceanfront villa with panoramic views, modern amenities, and luxurious finishes. Features include infinity pool, home theater, and smart home technology.', 'havenlytics') } 
  },
  { 
    id: FIELD_TYPES.LOCATION, 
    title: __('Location', 'havenlytics'), 
    icon: 'map-marker-alt', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { text: __('123 Ocean View Drive, Malibu, CA', 'havenlytics') } 
  },
  { 
    id: FIELD_TYPES.AVATAR, 
    title: __('Avatar', 'havenlytics'), 
    icon: 'user-circle', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { type: 'avatar', url: '' } 
  },
  { 
    id: FIELD_TYPES.KITCHENS, 
    title: __('Kitchens', 'havenlytics'), 
    icon: 'utensils', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '1' } 
  },
  { 
    id: FIELD_TYPES.FLOOR, 
    title: __('Floor', 'havenlytics'), 
    icon: 'layer-group', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '1' } 
  },
  { 
    id: FIELD_TYPES.ROOMS, 
    title: __('Rooms', 'havenlytics'), 
    icon: 'door-closed',
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '1' } 
  },
  { 
    id: FIELD_TYPES.PROPERTY_TYPE, 
    title: __('Property Type', 'havenlytics'), 
    icon: 'home', 
    mode: FIELD_MODES.BOTH,
    defaultValue: { text: __('Villa', 'havenlytics'), style: 'secondary' } 
  },
  { 
    id: FIELD_TYPES.GSFT, 
    title: __('Gsq ft', 'havenlytics'), 
    icon: 'warehouse',
    mode: FIELD_MODES.BOTH,
    defaultValue: { value: '50' } 
  }
];